import EditJoonDevice from './EditJoonDevice';

export default EditJoonDevice;
